import React from "react";
import Button from "reactstrap/es/Button";
import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";
import { ExpandMore, Launch } from "@material-ui/icons";

export const ProjectsComponent = () => {
    return (
        <div style={{
            paddingTop: "4%",
            paddingLeft: '4%',
            paddingRight: "4%",
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            flexWrap: "wrap",
        }}>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{ backgroundColor: "#FFFFFF", borderRadius: 30, marginBottom: "5%" }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <h4 style={{ textAlign: "center" }}><b>$ <span style={{
                            color: "#007BFF"
                        }}>parse</span> In Progress</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 20,
                        }}>
                            <span style={{ color: "#007BFF" }}>CoinHash</span>
                            <br />
                            A primitive crypto hash function.
                            <br />
                            <br />
                            <span style={{ color: "#007BFF" }}>EasyChat</span>
                            <br />
                            A Java-based chat system.
                        </div>
                    </AccordionDetails>
                </Accordion>
                <hr />
            </div>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{ backgroundColor: "#FFFFFF", borderRadius: 30, marginBottom: "5%" }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <h4 style={{ textAlign: "center" }}><b>$ <span style={{
                            color: "#007BFF"
                        }}>parse</span> PurdueEats</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 20,
                            flexDirection: "column", flexWrap: "wrap",
                        }}>
                            <h6><b>Jan 2021 — Present</b></h6>
                            <p style={{ lineHeight: 0, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Description</p>
                            <h6>A full stack mobile application, rooted in ML, to improve on Purdue University's current dining solutions.</h6>
                            <p style={{ lineHeight: 0, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Stack</p>
                            <h6>React Native, FastAPI, mySQL</h6>
                            <Button style={{ marginTop: 20, marginRight: 20, color: "black", backgroundColor: "#90EE90",
                                borderRadius: 10, outlineColor: "#3792CB" }}
                                    href={"https://github.com/PurdueEats"} target={"_blank"}
                            >
                                Check it out on GitHub (email for access)!  <sup><Launch style={{ height: "10", width: "10" }}/></sup>
                            </Button>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <hr />
            </div>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{ backgroundColor: "#FFFFFF", borderRadius: 30, marginBottom: "5%" }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <h4 style={{ textAlign: "center" }}><b>$ <span style={{
                            color: "#007BFF"
                        }}>parse</span> Indigo</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 20,
                            flexDirection: "column", flexWrap: "wrap",
                        }}>
                            <h6><b>Jun 2020 — Present</b></h6>
                            <p style={{ lineHeight: 0, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Description</p>
                            <h6> Web app for collecting and displaying Indianapolis business responses to COVID-19.</h6>
                            <p style={{ lineHeight: 0, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Stack</p>
                            <h6>ReactJS, Spring Boot, mySQL</h6>
                            <Button style={{ marginTop: 20, marginRight: 20, color: "black", backgroundColor: "#7735F6",
                                borderRadius: 10, outlineColor: "#3792CB" }}
                                href={"https://github.com/aniketagnihotri/Indigo"} target={"_blank"}
                            >
                                Check it out on GitHub!  <sup><Launch style={{ height: "10", width: "10" }}/></sup>
                            </Button>
                            <Button style={{ marginTop: 20, color: "black", backgroundColor: "#7735F6",
                                borderRadius: 10, outlineColor: "#3792CB" }}
                                    href={"https://devpost.com/software/indigo-7rw30z"} target={"_blank"}
                            >
                                Check it out on Devpost!  <sup><Launch style={{ height: "10", width: "10" }}/></sup>
                            </Button>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <hr />
            </div>
            <div>
                <Accordion
                    defaultExpanded={true}
                    style={{ backgroundColor: "#FFFFFF", borderRadius: 30, marginBottom: "5%" }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                    >
                        <h4><b>$ <span style={{
                            color: "#007BFF"
                        }}>parse</span> Partem</b></h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{
                            paddingLeft: "3%", paddingRight: "3%", paddingBottom: 20,
                            flexDirection: "column", flexWrap: "wrap",
                        }}>
                            <h6><b>Jan 2020 — Feb 2020</b></h6>
                            <p style={{ lineHeight: 0, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Description</p>
                            <h6>Mobile app for predicting partisan bias in various media.</h6>
                            <p style={{ lineHeight: 0, paddingTop: 20, color: "#007BFF", fontSize: "13" }}>Stack</p>
                            <h6>Google Cloud ML and C#</h6>
                            <Button style={{ marginTop: 20, color: "black", backgroundColor: "#007BFF",
                                borderRadius: 10, outlineColor: "#3792CB" }}
                                href={"https://devpost.com/software/partem-tech"} target={"_blank"}
                            >
                                Check it out on Devpost!  <sup><Launch style={{ height: "10", width: "10" }}/></sup>
                            </Button>
                        </div>
                    </AccordionDetails>
                </Accordion>
            </div>
        </div>
    );
}
